import React from 'react'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'
import { Typography } from '@telus/koodo-ui-kit'

const INSTRUCTION_BOLD_TOKENS = {
  color: '#000000',
  fontName: 'StagSans',
  fontSize: 14,
  fontWeight: 600,
  letterSpacing: 0,
  lineHeight: '20px'
}

const MarkdownParagraph = ({ children }) => <>{children}</>

MarkdownParagraph.propTypes = {
  children: PropTypes.node
}

const MarkdownStrong = ({ children }) => (
  <Typography
    tag="strong"
    variant={{ size: 14, color: '#000000' }}
    tokens={INSTRUCTION_BOLD_TOKENS}
  >
    {children}
  </Typography>
)

MarkdownStrong.propTypes = {
  children: PropTypes.node
}

const MarkdownLink = ({ href, children }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="text-black underline"
  >
    <Typography
      tag="span"
      variant={{ size: 14, bold: true, color: '#000000' }}
      tokens={INSTRUCTION_BOLD_TOKENS}
    >
      {children}
    </Typography>
  </a>
)

MarkdownLink.propTypes = {
  href: PropTypes.string,
  children: PropTypes.node
}

const instructionMarkdownComponents = {
  p: MarkdownParagraph,
  strong: MarkdownStrong,
  a: MarkdownLink
}

const allowedInstructionElements = ['p', 'strong', 'a']

const InlineInstructionMarkdown = ({ children }) => (
  <ReactMarkdown
    allowedElements={allowedInstructionElements}
    components={instructionMarkdownComponents}
    skipHtml
    unwrapDisallowed
  >
    {children || ''}
  </ReactMarkdown>
)

InlineInstructionMarkdown.propTypes = {
  children: PropTypes.string
}

export default InlineInstructionMarkdown
